/**
 * layout translations
 * Auto-split from staticTranslations.ts
 */

// ─── Common / Shared ─────────────────────────────────────────
export const common = {
  en: {
    loading: "Loading...", error: "Error", success: "Success",
    save: "Save", cancel: "Cancel", close: "Close", back: "Back",
    send: "Send", search: "Search", noResults: "No results found", required: "Required field",
  },
  ru: {
    loading: "Загрузка...", error: "Ошибка", success: "Успех",
    save: "Сохранить", cancel: "Отмена", close: "Закрыть", back: "Назад",
    send: "Отправить", search: "Поиск", noResults: "Ничего не найдено", required: "Обязательное поле",
  },
  ar: {
    loading: "جاري التحميل...", error: "خطأ", success: "نجاح",
    save: "حفظ", cancel: "إلغاء", close: "إغلاق", back: "رجوع",
    send: "إرسال", search: "بحث", noResults: "لم يتم العثور على نتائج", required: "حقل مطلوب",
  },
};

// ─── Footer ─────────────────────────────────────────
export const footer = {
  en: {
    tagline: "Jewelry & Watches since 1984",
    importantLinks: "Important Links",
    customerService: "Customer Service",
    contactInfo: "Contact Info",
    socialMedia: "Social Media",
    privacyPolicy: "Privacy Policy",
    termsOfUse: "Terms of Use",
    shippingPolicy: "Shipping Policy",
    returnPolicy: "Returns Policy",
    accessibility: "Accessibility Statement",
    cookiePolicy: "Cookie Policy",
    manageCookies: "Manage Cookies",
    faq: "FAQ",
    sizeGuide: "Size Guide",
    tradeIn: "Alice Trade-In",
    contactUs: "Contact Us",
    trackRepairs: "Repair Tracking",
    phone: "Phone: 079-5575576",
    whatsapp: "Whatsapp: 054-5267564",
    address: "Address: 58 Herzl St., Beer Sheva",
    facebook: "Facebook",
    instagram: "Instagram",
    tiktok: "TikTok",
    email: "Email",
    copyright: "© Alice | Jewelry & Watches 2025",
    allProducts: "View All Products",
    viewAllCategories: "View All Categories",
  },
  ru: {
    tagline: "Ювелирные изделия и часы с 1984",
    importantLinks: "Важные ссылки",
    customerService: "Обслуживание клиентов",
    contactInfo: "Контакты",
    socialMedia: "Соцсети",
    privacyPolicy: "Политика конфиденциальности",
    termsOfUse: "Условия использования",
    shippingPolicy: "Политика доставки",
    returnPolicy: "Политика возвратов",
    accessibility: "Заявление о доступности",
    cookiePolicy: "Политика cookies",
    manageCookies: "Управление cookies",
    faq: "Часто задаваемые вопросы",
    sizeGuide: "Гид по размерам",
    tradeIn: "Alice Trade-In",
    contactUs: "Связаться с нами",
    trackRepairs: "Отслеживание ремонта",
    phone: "Телефон: 079-5575576",
    whatsapp: "Whatsapp: 054-5267564",
    address: "Адрес: ул. Герцля 58, Беэр-Шева",
    facebook: "Facebook",
    instagram: "Instagram",
    tiktok: "TikTok",
    email: "Эл. почта",
    copyright: "© Alice | Ювелирные изделия и часы 2025",
    allProducts: "Все товары",
    viewAllCategories: "Все категории",
  },
  ar: {
    tagline: "مجوهرات وساعات منذ 1984",
    importantLinks: "روابط مهمة",
    customerService: "خدمة العملاء",
    contactInfo: "معلومات الاتصال",
    socialMedia: "وسائل التواصل",
    privacyPolicy: "سياسة الخصوصية",
    termsOfUse: "شروط الاستخدام",
    shippingPolicy: "سياسة الشحن",
    returnPolicy: "سياسة الإرجاع",
    accessibility: "بيان إمكانية الوصول",
    cookiePolicy: "سياسة ملفات تعريف الارتباط",
    manageCookies: "إدارة ملفات تعريف الارتباط",
    faq: "الأسئلة الشائعة",
    sizeGuide: "دليل المقاسات",
    tradeIn: "Alice Trade-In",
    contactUs: "اتصل بنا",
    trackRepairs: "تتبع الإصلاحات",
    phone: "الهاتف: 079-5575576",
    whatsapp: "واتساب: 054-5267564",
    address: "العنوان: شارع هرتسل 58، بئر السبع",
    facebook: "فيسبوك",
    instagram: "إنستغرام",
    tiktok: "تيك توك",
    email: "البريد الإلكتروني",
    copyright: "© أليس | مجوهرات وساعات 2025",
    allProducts: "عرض جميع المنتجات",
    viewAllCategories: "عرض جميع الفئات",
  },
};

// ─── Header ─────────────────────────────────────────
export const header = {
  en: {
    home: "Home", blog: "Blog", aboutUs: "About", giftCard: "GiftCard",
    customerService: "Customer Service", contactUs: "Contact Us", faq: "FAQ",
    sizeGuide: "Size Guide", tradeIn: "Alice Trade In", trackRepairs: "Repair Tracking",
    back: "Back", viewCollection: "View Collection", personalArea: "Personal Area",
    login: "Login", accessibility: "Accessibility", wishlist: "Wishlist", language: "Language",
    socialFollow: "Follow us and stay updated on everything new! In our store and the jewelry world:",
    socialTitle: "Social Media", orderInfo: "Orders & Customer Service",
    terms: "Terms of Use", returnsPolicy: "Returns & Cancellation Policy",
    accessibilityStatement: "Accessibility Statement", ringSizeGuide: "Size Guide",
    giftCardFooter: "Gift Card", repairTracking: "Repair Tracking",
    ourApp: "Our App", downloadHere: "Download here",
    phone: "Phone", fax: "Fax", address: "Address",
    businessHours: "Business Hours",
    sunday: "Sunday", monday: "Monday", tuesday: "Tuesday", wednesday: "Wednesday",
    thursday: "Thursday", fridayHolidays: "Friday & Holiday Eves",
    saturdayHolidays: "Saturdays & Holidays", closed: "Closed",
    copyright: "© Alice | Jewelry & Watches 2025",
    chooseLanguage: "Choose language",
    ourCollection: "Our Collection", viewAll: "View",
  },
  ru: {
    home: "Главная", blog: "Блог", aboutUs: "О нас", giftCard: "GiftCard",
    customerService: "Обслуживание", contactUs: "Связаться", faq: "FAQ",
    sizeGuide: "Гид по размерам", tradeIn: "Alice Trade In", trackRepairs: "Отслеживание ремонта",
    back: "Назад", viewCollection: "Посмотреть коллекцию", personalArea: "Личный кабинет",
    login: "Вход", accessibility: "Доступность", wishlist: "Избранное", language: "Язык",
    socialFollow: "Следите за нами и будьте в курсе всех новинок!",
    socialTitle: "Соцсети", orderInfo: "Заказы и обслуживание",
    terms: "Условия использования", returnsPolicy: "Политика возвратов и отмены",
    accessibilityStatement: "Заявление о доступности", ringSizeGuide: "Гид по размерам",
    giftCardFooter: "Подарочная карта", repairTracking: "Отслеживание ремонта",
    ourApp: "Наше приложение", downloadHere: "Скачать здесь",
    phone: "Телефон", fax: "Факс", address: "Адрес",
    businessHours: "Часы работы",
    sunday: "Воскресенье", monday: "Понедельник", tuesday: "Вторник", wednesday: "Среда",
    thursday: "Четверг", fridayHolidays: "Пятница и кануны праздников",
    saturdayHolidays: "Суббота и праздники", closed: "Закрыто",
    copyright: "© Alice | Ювелирные изделия и часы 2025",
    chooseLanguage: "Выберите язык",
    ourCollection: "Наша коллекция", viewAll: "Посмотреть",
  },
  ar: {
    home: "الرئيسية", blog: "المدونة", aboutUs: "نبذة عنا", giftCard: "GiftCard",
    customerService: "خدمة العملاء", contactUs: "اتصل بنا", faq: "الأسئلة الشائعة",
    sizeGuide: "دليل المقاسات", tradeIn: "Alice Trade In", trackRepairs: "تتبع الإصلاحات",
    back: "رجوع", viewCollection: "عرض المجموعة", personalArea: "المنطقة الشخصية",
    login: "تسجيل الدخول", accessibility: "إمكانية الوصول", wishlist: "المفضلة", language: "اللغة",
    socialFollow: "تابعونا وابقوا على اطلاع بكل جديد!",
    socialTitle: "وسائل التواصل", orderInfo: "الطلبات وخدمة العملاء",
    terms: "شروط الاستخدام", returnsPolicy: "سياسة الإرجاع والإلغاء",
    accessibilityStatement: "بيان إمكانية الوصول", ringSizeGuide: "دليل المقاسات",
    giftCardFooter: "بطاقة هدايا", repairTracking: "تتبع الإصلاحات",
    ourApp: "تطبيقنا", downloadHere: "اضغط هنا للتحميل",
    phone: "الهاتف", fax: "الفاكس", address: "العنوان",
    businessHours: "ساعات العمل",
    sunday: "الأحد", monday: "الإثنين", tuesday: "الثلاثاء", wednesday: "الأربعاء",
    thursday: "الخميس", fridayHolidays: "الجمعة وعشية الأعياد",
    saturdayHolidays: "السبت والأعياد", closed: "مغلق",
    copyright: "© أليس | مجوهرات وساعات 2025",
    chooseLanguage: "اختر اللغة",
    ourCollection: "مجموعتنا", viewAll: "عرض",
  },
};

// ─── Newsletter ─────────────────────────────────────────
export const newsletter = {
  en: {
    subtitle: "Sign up for hot deals",
    title: "Join our Newsletter",
    emailLabel: "Email",
    sending: "Sending...",
    subscribe: "Subscribe",
    consent: "By subscribing I agree to receive emails and updates and confirm I have read the site's",
    termsOfUse: "Terms of Use",
    privacyPolicy: "Privacy Policy",
    error: "Error",
    enterEmail: "Please enter an email address",
    invalidEmail: "Please enter a valid email address",
    consentRequired: "You must accept the newsletter terms",
    success: "Subscribed successfully!",
    thankYou: "Thank you for joining our newsletter",
    subscribeError: "An error occurred, please try again later",
  },
  ru: {
    subtitle: "Подпишитесь на горячие предложения",
    title: "Присоединяйтесь к рассылке",
    emailLabel: "Эл. почта",
    sending: "Отправка...",
    subscribe: "Подписаться",
    consent: "Подписываясь, я соглашаюсь получать письма и подтверждаю, что ознакомился с",
    termsOfUse: "Условия использования",
    privacyPolicy: "Политика конфиденциальности",
    error: "Ошибка",
    enterEmail: "Введите адрес эл. почты",
    invalidEmail: "Введите корректный адрес эл. почты",
    consentRequired: "Необходимо согласиться с условиями",
    success: "Подписка оформлена!",
    thankYou: "Спасибо за подписку на нашу рассылку",
    subscribeError: "Произошла ошибка, попробуйте позже",
  },
  ar: {
    subtitle: "اشترك في العروض الساخنة",
    title: "انضم إلى نشرتنا الإخبارية",
    emailLabel: "البريد الإلكتروني",
    sending: "جاري الإرسال...",
    subscribe: "اشتراك",
    consent: "بالاشتراك أوافق على تلقي رسائل وأؤكد أنني قرأت",
    termsOfUse: "شروط الاستخدام",
    privacyPolicy: "سياسة الخصوصية",
    error: "خطأ",
    enterEmail: "يرجى إدخال عنوان البريد الإلكتروني",
    invalidEmail: "يرجى إدخال عنوان بريد إلكتروني صالح",
    consentRequired: "يجب الموافقة على شروط النشرة",
    success: "تم الاشتراك بنجاح!",
    thankYou: "شكرًا لانضمامك إلى نشرتنا",
    subscribeError: "حدث خطأ، يرجى المحاولة لاحقًا",
  },
};

// ─── Homepage sections ─────────────────────────────────────────
export const homepage = {
  en: {
    featuredCategories: "Featured Categories",
    viewAllProducts: "View all products in category",
    loadingProducts: "Loading products...",
    noProducts: "No products found in this category",
    loading: "Loading...",
  },
  ru: {
    featuredCategories: "Популярные категории",
    viewAllProducts: "Все товары категории",
    loadingProducts: "Загрузка товаров...",
    noProducts: "Товары в этой категории не найдены",
    loading: "Загрузка...",
  },
  ar: {
    featuredCategories: "الفئات المميزة",
    viewAllProducts: "عرض جميع منتجات الفئة",
    loadingProducts: "جاري تحميل المنتجات...",
    noProducts: "لم يتم العثور على منتجات في هذه الفئة",
    loading: "جاري التحميل...",
  },
};

// ─── WhyUs Section ─────────────────────────────────────────
export const whyUs = {
  en: {
    sectionLabel: "Why Us?",
    title: "What Makes Us",
    titleHighlight: "Special",
    description: "We don't just sell jewelry - we create a perfect experience from start to long after purchase. Our customers enjoy exceptional service, uncompromising quality and lasting support.",
    viewAllProducts: "View All Products",
    reason1Title: "Full Warranty",
    reason1Desc: "We provide full warranty on all our products. Every piece undergoes rigorous quality testing and comes with comprehensive manufacturer warranty.",
    reason2Title: "Personal Support",
    reason2Desc: "Our team is always available for you. We provide personal consultation, help choose the perfect jewelry and respond quickly to any question.",
    reason3Title: "Uncompromising Quality",
    reason3Desc: "We work only with top-tier raw materials and highest quality diamonds. Every piece is carefully crafted by skilled artisans meeting the strictest international standards.",
    reason4Title: "Fair Prices",
    reason4Desc: "We believe quality service and luxury products don't have to come with excessive prices. We offer fair and competitive prices without compromising quality.",
    reason5Title: "Unique Design",
    reason5Desc: "Our collections combine classic design with a modern, unique touch. We also offer custom design services so you can create jewelry that reflects your personality.",
  },
  ru: {
    sectionLabel: "Почему мы?",
    title: "Что делает нас",
    titleHighlight: "особенными",
    description: "Мы не просто продаём украшения — мы создаём идеальный опыт от начала и до долгого времени после покупки.",
    viewAllProducts: "Все товары",
    reason1Title: "Полная гарантия",
    reason1Desc: "Мы предоставляем полную гарантию на все наши товары. Каждое украшение проходит тщательную проверку качества.",
    reason2Title: "Личная поддержка",
    reason2Desc: "Наша команда всегда доступна для вас. Мы предоставляем персональные консультации и помогаем выбрать идеальное украшение.",
    reason3Title: "Бескомпромиссное качество",
    reason3Desc: "Мы работаем только с лучшими материалами и бриллиантами высочайшего качества.",
    reason4Title: "Справедливые цены",
    reason4Desc: "Мы предлагаем справедливые и конкурентные цены без ущерба качеству.",
    reason5Title: "Уникальный дизайн",
    reason5Desc: "Наши коллекции сочетают классический дизайн с современным уникальным стилем.",
  },
  ar: {
    sectionLabel: "لماذا نحن؟",
    title: "ما يجعلنا",
    titleHighlight: "مميزين",
    description: "نحن لا نبيع المجوهرات فقط - نحن نخلق تجربة مثالية من البداية وحتى ما بعد الشراء بوقت طويل.",
    viewAllProducts: "عرض جميع المنتجات",
    reason1Title: "ضمان كامل",
    reason1Desc: "نقدم ضمانًا كاملاً على جميع منتجاتنا. كل قطعة تخضع لفحص جودة دقيق.",
    reason2Title: "دعم شخصي",
    reason2Desc: "فريقنا متاح لكم دائمًا. نقدم استشارات شخصية ونساعدكم في اختيار المجوهرات المثالية.",
    reason3Title: "جودة بلا تنازلات",
    reason3Desc: "نعمل فقط مع أفضل المواد الخام والماس عالي الجودة.",
    reason4Title: "أسعار عادلة",
    reason4Desc: "نقدم أسعارًا عادلة وتنافسية دون المساس بالجودة.",
    reason5Title: "تصميم فريد",
    reason5Desc: "مجموعاتنا تجمع بين التصميم الكلاسيكي واللمسة العصرية الفريدة.",
  },
};

// ─── WhyChoose Accordion Section ─────────────────────────────
export const whyChoose = {
  en: {
    sectionLabel: "Why Choose Us",
    title: "Our Advantages",
    feature1: "Highest Quality Diamonds",
    feature1Desc: "We work exclusively with the highest quality diamonds, certified by leading international laboratories. Every diamond undergoes rigorous testing and comes with a detailed quality certificate.",
    feature2: "Design & Uniqueness",
    feature2Desc: "Our collections combine classic design with a modern, personal touch. We also offer full custom design services to create unique jewelry that reflects your personality.",
    feature3: "Fair & Transparent Prices",
    feature3Desc: "We believe quality jewelry should be accessible. By working directly with leading manufacturers, we offer fair and competitive prices with complete transparency.",
    feature4: "Professional & Personal Service",
    feature4Desc: "Our experienced team provides professional and personal guidance throughout the entire process - from initial selection to after purchase. Our maintenance and adjustment services are always available.",
    feature5: "Decades of Experience",
    feature5Desc: "Since 1984, Alice Jewelry has been providing excellent service throughout the south. Our extensive experience allows us to understand your needs and offer personalized solutions.",
    feature6: "Warranty & After-Sales Service",
    feature6Desc: "We offer comprehensive warranty on all our jewelry and professional repair and maintenance service. Our team is available for any question even after purchase.",
  },
  ru: {
    sectionLabel: "Почему выбирают нас",
    title: "Наши преимущества",
    feature1: "Бриллианты высочайшего качества",
    feature1Desc: "Мы работаем исключительно с бриллиантами высочайшего качества, сертифицированными ведущими международными лабораториями.",
    feature2: "Дизайн и уникальность",
    feature2Desc: "Наши коллекции сочетают классический дизайн с современным и персональным стилем. Мы также предлагаем услуги индивидуального дизайна.",
    feature3: "Справедливые и прозрачные цены",
    feature3Desc: "Работая напрямую с производителями, мы предлагаем справедливые цены с полной прозрачностью.",
    feature4: "Профессиональный и личный сервис",
    feature4Desc: "Наша опытная команда сопровождает вас на каждом этапе — от выбора до послепродажного обслуживания.",
    feature5: "Десятилетия опыта",
    feature5Desc: "С 1984 года Alice Jewelry предоставляет отличный сервис на юге Израиля.",
    feature6: "Гарантия и послепродажное обслуживание",
    feature6Desc: "Мы предоставляем комплексную гарантию на все украшения и профессиональный сервис ремонта.",
  },
  ar: {
    sectionLabel: "لماذا تختارنا",
    title: "مزايانا",
    feature1: "ألماس بأعلى جودة",
    feature1Desc: "نعمل حصريًا مع ألماس بأعلى جودة، معتمد من مختبرات دولية رائدة.",
    feature2: "تصميم وتميز",
    feature2Desc: "مجموعاتنا تجمع بين التصميم الكلاسيكي واللمسة العصرية الشخصية. نقدم أيضًا خدمات تصميم مخصصة.",
    feature3: "أسعار عادلة وشفافة",
    feature3Desc: "بالعمل مباشرة مع المصنعين، نقدم أسعارًا عادلة مع شفافية كاملة.",
    feature4: "خدمة مهنية وشخصية",
    feature4Desc: "فريقنا المتمرس يرافقكم في كل مرحلة — من الاختيار الأولي وحتى ما بعد الشراء.",
    feature5: "عقود من الخبرة",
    feature5Desc: "منذ 1984، تقدم أليس للمجوهرات خدمة ممتازة في جنوب إسرائيل.",
    feature6: "ضمان وخدمة ما بعد البيع",
    feature6Desc: "نقدم ضمانًا شاملاً على جميع المجوهرات وخدمة إصلاح وصيانة احترافية.",
  },
};

// ─── SEO - Titles, Descriptions & Breadcrumbs ─────────────
export const seo = {
  en: {
    siteName: "Alice | Jewellery & Watches",
    homeTitle: "Alice Jewellery | Jewellery & Watches in Beer Sheva Since 1984",
    homeDescription: "Alice Jewellery – the leading jewellery store in Beer Sheva since 1984. Huge selection of engagement rings, gold necklaces, bracelets, earrings and luxury watches. Online shop with shipping across Israel.",
    shopTitle: "Online Jewellery Store",
    shopDescription: "Alice online jewellery store – huge selection of 14K gold jewellery, engagement rings, necklaces, earrings and bracelets. Free shipping and full warranty.",
    contactTitle: "Contact Us",
    contactDescription: "Contact Alice Jewellery & Watches – visit us at 58 Herzl St., Beer Sheva, call 079-5575576 or send us a message.",
    aboutTitle: "About Us – Alice Jewellery",
    aboutDescription: "Alice Jewellery – the leading jewellery company in the south since 1984. Specialising in engagement rings, wedding rings, gold jewellery and luxury watches.",
    faqTitle: "Frequently Asked Questions",
    faqDescription: "Answers to frequently asked questions about jewellery, orders, shipping, returns and warranty at Alice Jewellery.",
    blogTitle: "Jewellery Blog – Alice",
    blogDescription: "Alice Jewellery blog – articles, tips and guides on jewellery, engagement rings, gold and latest trends.",
    privacyTitle: "Privacy Policy",
    privacyDescription: "Alice Jewellery privacy policy – how we collect, use and protect your personal information.",
    termsTitle: "Terms of Use",
    termsDescription: "Terms and conditions of Alice Jewellery online store – purchase, shipping, returns and legal terms.",
    shippingTitle: "Shipping Policy",
    shippingDescription: "Alice Jewellery shipping policy – home delivery, self-pickup, delivery times and costs. Shipping throughout Israel.",
    returnsTitle: "Returns & Exchanges Policy",
    returnsDescription: "Alice Jewellery returns and exchanges policy – how to return or exchange products, deadlines and conditions.",
    accessibilityTitle: "Accessibility Statement",
    accessibilityDescription: "Alice Jewellery accessibility statement – our commitment to making the website accessible to all users.",
    giftCardTitle: "Gift Card – Alice Jewellery",
    giftCardDescription: "Alice Jewellery gift card – the perfect gift. Choose an amount and send to a loved one.",
    trackOrderTitle: "Track Order",
    trackOrderDescription: "Track your order or repair status at Alice Jewellery.",
    ringSizeTitle: "Ring Size Guide",
    ringSizeDescription: "Complete guide to measuring your ring size at home – ring size chart and simple measuring methods.",
    cookieTitle: "Cookie Policy",
    cookieDescription: "Alice Jewellery cookie policy – how we use cookies and how you can manage your preferences.",
    cartTitle: "Shopping Cart",
    cartDescription: "Your shopping cart at Alice Jewellery.",
    authTitle: "Login / Sign Up",
    authDescription: "Login or create an account at Alice Jewellery – manage your orders and get personal discounts.",
    wishlistTitle: "Wishlist",
    wishlistDescription: "Your wishlist at Alice Jewellery – save your favourite jewellery and share with friends and family.",
    // Breadcrumbs
    home: "Home",
    breadcrumbShipping: "Shipping Policy",
    breadcrumbReturns: "Returns & Exchanges",
    breadcrumbPrivacy: "Privacy Policy",
    breadcrumbTerms: "Terms of Use",
    breadcrumbFaq: "FAQ",
    breadcrumbBlog: "Blog",
    breadcrumbAccessibility: "Accessibility",
    breadcrumbGiftCard: "Gift Card",
    breadcrumbRingSize: "Ring Size Guide",
    breadcrumbCookie: "Cookie Policy",
    breadcrumbWishlist: "Wishlist",
    // Organization schema
    orgDescription: "Leading jewellery company in Beer Sheva since 1984. Online jewellery store – engagement rings, wedding rings, bracelets, necklaces, pendants & earrings.",
    // Navigation
    navEarrings: "Gold Earrings",
    navNecklaces: "Necklaces with Pendant",
    navRings: "Alice Rings",
    navBracelets: "Bracelets",
    navBlog: "Jewellery Blog",
    navStore: "Jewellery Store in Beer Sheva, Herzl 58",
    navFaq: "FAQ",
    navAbout: "About",
  },
  ru: {
    siteName: "Алиса | Ювелирные изделия и часы",
    homeTitle: "Ювелирные изделия Алиса | Украшения и часы в Беэр-Шеве с 1984 года",
    homeDescription: "Ювелирные изделия Алиса – ведущий ювелирный магазин в Беэр-Шеве с 1984 года. Огромный выбор помолвочных колец, золотых цепочек, браслетов, серёг и часов класса люкс. Интернет-магазин с доставкой по Израилю.",
    shopTitle: "Интернет-магазин ювелирных изделий",
    shopDescription: "Интернет-магазин Алиса – золотые украшения 14К, помолвочные кольца, цепочки, серьги и браслеты. Бесплатная доставка и полная гарантия.",
    contactTitle: "Свяжитесь с нами",
    contactDescription: "Свяжитесь с Алиса Ювелирные изделия – посетите нас: ул. Герцля 58, Беэр-Шева, тел. 079-5575576.",
    aboutTitle: "О нас – Алиса Ювелирные изделия",
    aboutDescription: "Алиса – ведущая ювелирная компания юга с 1984 года. Помолвочные кольца, обручальные кольца, золотые украшения и люксовые часы.",
    faqTitle: "Часто задаваемые вопросы",
    faqDescription: "Ответы на частые вопросы о ювелирных изделиях, заказах, доставке, возвратах и гарантии в Алиса.",
    blogTitle: "Блог о ювелирных изделиях – Алиса",
    blogDescription: "Блог Алиса – статьи, советы и руководства по ювелирным изделиям, помолвочным кольцам и трендам.",
    privacyTitle: "Политика конфиденциальности",
    privacyDescription: "Политика конфиденциальности Алиса – как мы собираем, используем и защищаем вашу личную информацию.",
    termsTitle: "Условия использования",
    termsDescription: "Условия использования интернет-магазина Алиса – покупка, доставка, возвраты и юридические условия.",
    shippingTitle: "Политика доставки",
    shippingDescription: "Политика доставки Алиса – доставка на дом, самовывоз, сроки и стоимость. Доставка по всему Израилю.",
    returnsTitle: "Политика возвратов и обменов",
    returnsDescription: "Политика возвратов и обменов Алиса – как вернуть или обменять товар, сроки и условия.",
    accessibilityTitle: "Заявление о доступности",
    accessibilityDescription: "Заявление о доступности Алиса – наше обязательство сделать сайт доступным для всех пользователей.",
    giftCardTitle: "Подарочная карта – Алиса",
    giftCardDescription: "Подарочная карта Алиса – идеальный подарок. Выберите сумму и отправьте близкому человеку.",
    trackOrderTitle: "Отслеживание заказа",
    trackOrderDescription: "Отслеживание статуса заказа или ремонта в Алиса.",
    ringSizeTitle: "Гид по размерам колец",
    ringSizeDescription: "Полное руководство по измерению размера кольца дома – таблица размеров и простые методы измерения.",
    cookieTitle: "Политика cookies",
    cookieDescription: "Политика использования cookie-файлов Алиса – как мы используем cookies и как вы можете управлять настройками.",
    cartTitle: "Корзина",
    cartDescription: "Ваша корзина в Алиса.",
    authTitle: "Вход / Регистрация",
    authDescription: "Войдите или создайте аккаунт в Алиса – управляйте заказами и получайте персональные скидки.",
    wishlistTitle: "Избранное",
    wishlistDescription: "Ваш список избранного в Алиса – сохраняйте любимые украшения и делитесь с друзьями.",
    home: "Главная",
    breadcrumbShipping: "Политика доставки",
    breadcrumbReturns: "Возвраты и обмены",
    breadcrumbPrivacy: "Конфиденциальность",
    breadcrumbTerms: "Условия использования",
    breadcrumbFaq: "Вопросы и ответы",
    breadcrumbBlog: "Блог",
    breadcrumbAccessibility: "Доступность",
    breadcrumbGiftCard: "Подарочная карта",
    breadcrumbRingSize: "Гид по размерам колец",
    breadcrumbCookie: "Политика cookies",
    breadcrumbWishlist: "Избранное",
    orgDescription: "Ведущая ювелирная компания в Беэр-Шеве с 1984 года. Интернет-магазин – помолвочные и обручальные кольца, браслеты, цепочки, подвески и серьги.",
    navEarrings: "Золотые серьги",
    navNecklaces: "Цепочки с подвеской",
    navRings: "Кольца Алиса",
    navBracelets: "Браслеты",
    navBlog: "Блог о ювелирных изделиях",
    navStore: "Ювелирный магазин в Беэр-Шеве, Герцля 58",
    navFaq: "Вопросы и ответы",
    navAbout: "О нас",
  },
  ar: {
    siteName: "أليس | مجوهرات وساعات",
    homeTitle: "مجوهرات أليس | مجوهرات وساعات في بئر السبع منذ 1984",
    homeDescription: "مجوهرات أليس – متجر المجوهرات الرائد في بئر السبع منذ 1984. تشكيلة ضخمة من خواتم الخطبة، قلائد الذهب، الأساور، الأقراط وساعات فاخرة. متجر أونلاين مع شحن لجميع أنحاء إسرائيل.",
    shopTitle: "متجر مجوهرات أونلاين",
    shopDescription: "متجر أليس للمجوهرات أونلاين – تشكيلة ضخمة من مجوهرات ذهب 14 قيراط، خواتم خطبة، قلائد، أقراط وأساور. شحن مجاني وضمان كامل.",
    contactTitle: "اتصل بنا",
    contactDescription: "تواصل مع أليس للمجوهرات والساعات – زورونا في شارع هرتسل 58، بئر السبع، هاتف 079-5575576.",
    aboutTitle: "عن أليس – مجوهرات",
    aboutDescription: "أليس للمجوهرات – الشركة الرائدة في الجنوب منذ 1984. خواتم خطبة وزواج ومجوهرات ذهبية وساعات فاخرة.",
    faqTitle: "أسئلة شائعة",
    faqDescription: "إجابات على الأسئلة الشائعة حول المجوهرات والطلبات والشحن والإرجاع والضمان في أليس.",
    blogTitle: "مدوّنة المجوهرات – أليس",
    blogDescription: "مدوّنة أليس للمجوهرات – مقالات ونصائح وأدلة حول المجوهرات وخواتم الخطبة والذهب وأحدث الصيحات.",
    privacyTitle: "سياسة الخصوصية",
    privacyDescription: "سياسة خصوصية أليس – كيف نجمع ونستخدم ونحمي معلوماتك الشخصية.",
    termsTitle: "شروط الاستخدام",
    termsDescription: "شروط وأحكام متجر أليس – الشراء والشحن والإرجاع والشروط القانونية.",
    shippingTitle: "سياسة الشحن",
    shippingDescription: "سياسة شحن أليس – توصيل للمنزل، استلام ذاتي، مواعيد التسليم والتكاليف. شحن لجميع أنحاء إسرائيل.",
    returnsTitle: "سياسة الإرجاع والاستبدال",
    returnsDescription: "سياسة إرجاع واستبدال أليس – كيفية إرجاع أو استبدال المنتجات والمواعيد والشروط.",
    accessibilityTitle: "بيان إمكانية الوصول",
    accessibilityDescription: "بيان إمكانية الوصول لأليس – التزامنا بجعل الموقع متاحاً لجميع المستخدمين.",
    giftCardTitle: "بطاقة هدية – أليس",
    giftCardDescription: "بطاقة هدية أليس – الهدية المثالية. اختر مبلغاً وأرسل لشخص عزيز.",
    trackOrderTitle: "تتبع الطلب",
    trackOrderDescription: "تتبع حالة طلبك أو إصلاحك في أليس للمجوهرات.",
    ringSizeTitle: "دليل مقاسات الخواتم",
    ringSizeDescription: "دليل شامل لقياس مقاس الخاتم في المنزل – جدول المقاسات وطرق قياس بسيطة.",
    cookieTitle: "سياسة ملفات تعريف الارتباط",
    cookieDescription: "سياسة ملفات تعريف الارتباط لأليس – كيف نستخدم ملفات تعريف الارتباط وكيف يمكنك إدارة تفضيلاتك.",
    cartTitle: "سلة التسوق",
    cartDescription: "سلة التسوق الخاصة بك في أليس.",
    authTitle: "تسجيل الدخول / إنشاء حساب",
    authDescription: "سجّل الدخول أو أنشئ حساباً في أليس – أدر طلباتك واحصل على خصومات شخصية.",
    wishlistTitle: "المفضلة",
    wishlistDescription: "قائمة المفضلة في أليس – احفظ مجوهراتك المفضلة وشاركها مع الأصدقاء والعائلة.",
    home: "الرئيسية",
    breadcrumbShipping: "سياسة الشحن",
    breadcrumbReturns: "الإرجاع والاستبدال",
    breadcrumbPrivacy: "سياسة الخصوصية",
    breadcrumbTerms: "شروط الاستخدام",
    breadcrumbFaq: "أسئلة شائعة",
    breadcrumbBlog: "المدوّنة",
    breadcrumbAccessibility: "إمكانية الوصول",
    breadcrumbGiftCard: "بطاقة هدية",
    breadcrumbRingSize: "دليل مقاسات الخواتم",
    breadcrumbCookie: "سياسة ملفات تعريف الارتباط",
    breadcrumbWishlist: "المفضلة",
    orgDescription: "شركة المجوهرات الرائدة في بئر السبع منذ 1984. متجر أونلاين – خواتم خطبة وزواج وأساور وقلائد وأقراط.",
    navEarrings: "أقراط ذهبية",
    navNecklaces: "قلائد مع تعليقة",
    navRings: "خواتم أليس",
    navBracelets: "أساور",
    navBlog: "مدوّنة المجوهرات",
    navStore: "متجر مجوهرات في بئر السبع، هرتسل 58",
    navFaq: "أسئلة شائعة",
    navAbout: "عن أليس",
  },
};
